import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, putData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import ChatBotWhatsappCad from '../../pages/pedidos/ChatBotWhatsappCad';


const ChatBotWhatsappContext = createContext();

export const useChatBotWhatsapp = () => useContext(ChatBotWhatsappContext);

export const ChatBotWhatsappProvider = ({ children }) => {
    const [chatBotWhatsapp, setChatBotWhatsapp] = useState();
    const { showAlert } = useAlert();

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/ChatBotWhatsapp');
                setChatBotWhatsapp(result);
            } catch (error) {
                console.error("Erro ao buscar configurações do ChatBot WhatsApp:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const updateChatBotWhatsapp = async (chatBotWhatsapp) => {
        try {
            const result = await putData('/ChatBotWhatsapp', chatBotWhatsapp);
            setChatBotWhatsapp(result);
            showAlert('Configuração do ChatBot WhatsApp alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar configuração do ChatBot WhatsApp:", error);
            showAlert('Erro ao alterar configuração do ChatBot WhatsApp!', 'danger');
        }
    };

    // Modal Cadastro ChatBot WhatsApp
    const [showModalChatBot, setShowModalChatBot] = useState(false);
    const showChatBotCad = () => {
        setShowModalChatBot(true);
    };

    const handleCloseModalChatBot = () => {
        setShowModalChatBot(false);
    };

    return (
        <ChatBotWhatsappContext.Provider value={{ chatBotWhatsapp, setChatBotWhatsapp, updateChatBotWhatsapp, showChatBotCad }}>
            {children}
            <ChatBotWhatsappCad
                show={showModalChatBot}
                onHide={handleCloseModalChatBot}
            />
        </ChatBotWhatsappContext.Provider>
    );
};